import U2000SaveCancel from "./U2000SaveCancel";
import type { U2000FormStateHandlers } from "../../../reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../reducer/formReducer/U2000FormState";

interface U2000CommonFormFooterActionsProps<T extends Record<string, any>> {
  formStateHandlers: U2000FormStateHandlers<T>;
}

const U2000CommonFormFooterActions = <T extends Record<string, any>>({ formStateHandlers }: U2000CommonFormFooterActionsProps<T>) => {
  const state = formStateHandlers.getFormState();
  return (
    <>
      <div className={`mt-8 flex items-center justify-end gap-2 border-t pt-4 ${state === U2000FormStateEnumState.READ ? "hidden" : ""}`}>
        <U2000SaveCancel formStateHandlers={formStateHandlers} />
      </div>
    </>
  );
};

export default U2000CommonFormFooterActions;
